import React from "react";
import { motion } from "framer-motion";
import { cardItem, fadeUp, staggerContainer, viewportOnce } from "lib/animations";
import TiltCard from "lib/components/atomic/TiltCard";
import { UsersThree, Buildings } from "@phosphor-icons/react";

const features = [

  {
    title: "Mentors from Pulchowk",
    description:
      "Taught by engineers who cracked the IOE entrance themselves, not career tutors.",
  },
  {
    title: "Authentic Questions",
    description:
      "Curated from the best sources and cross-checked for authenticity.",
  },
  {
    title: "Chapterwise Practice Sets",
    description:
      "Hundreds of questions per chapter, aligned to the IOE and CSIT syllabus.",
  },
  {
    title: "Scheduled Exams",
    description:
      "Weekly mock exams across IOE, CSIT, and IOE MSc boards. Pick your shift.",
  },

  {
    title: "Online or In-Person",
    description:
      "Live classes streamed nationwide, or attend in person at our Kathmandu classroom — same mock tests, same mentors, either way.",
    icon: <Buildings weight="duotone" />,
  },
  {
    title: "100,000+ Learner Community",
    description:
      "A Discord community of learners and mentors trading doubts, notes, and advice from past toppers every day.",
    icon: <UsersThree weight="duotone" />,
  },
];

const ClamphookFeatures = () => {
  return (
    <section className="features_section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-10">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="max-w-3xl mb-10 md:mb-14"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gray-500">
            Why Clamphook
          </p>
          <h4 className="mt-2 text-3xl md:text-4xl font-black tracking-tight text-gray-900">
            Six reasons students choose <span className="text-primary">Clamphook</span>
          </h4>
        </motion.div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="grid sm:grid-cols-2 xl:grid-cols-3 border-t border-l border-gray-200 bg-transparent"
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              variants={cardItem}
              whileHover={{ y: -4, backgroundColor: "rgba(249, 250, 251, 0.5)" }}
              whileTap={{ scale: 0.98 }}
              className="border-r border-b border-gray-200 p-6 md:p-7 transition-colors cursor-pointer"
            >
              <h5 className="text-lg font-bold text-gray-900">
                <span className="text-primary-600 text-2xl md:text-3xl font-black mr-1">{index + 1}.</span> {feature.title}
              </h5>
              <p className="mt-2 text-sm leading-7 text-gray-600 font-normal">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ClamphookFeatures;
